export default __webpack_public_path__ + "086a8c88cf93ce0c6b1c315cfd84ae2f.jpg";